<template>
  <div class="prospectos-wrap">
    <v-card class="prospectos-card elevation-0" tile>
      <v-toolbar flat class="prospectos-hero">
        <div class="d-flex align-center" style="gap: 12px;">
          <v-avatar color="white" size="44" class="elevation-2">
            <v-icon color="green darken-4">mdi-account-group</v-icon> 
          </v-avatar>
          <div>
            <div class="text-h6 white--text">Embudo comercial</div>
            <div class="text-body-2 white--text">
              Gestiona contactos, prospectos y pre-inscritos en un solo lugar
            </div>
          </div>
        </div>
        <v-spacer></v-spacer>
        <!-- <v-chip color="green darken-2" class="white--text text--darken-4" small>
          Activo
        </v-chip> -->
        <v-btn color="white" small rounded outlined dark @click="$router.push('/reporte-contactos')">
           <v-icon small>mdi-finance</v-icon>
           Reportes
        </v-btn>
      </v-toolbar>

      <v-tabs v-model="tab" align-with-title class="prospectos-tabs" grow>
        <v-tabs-slider color="green"></v-tabs-slider>

        <v-tab>
          <v-icon left>mdi-account</v-icon>
          Contactos
          <v-chip x-small class="ml-2 white--text" color="green darken-2">1</v-chip>
        </v-tab>
        <v-tab>
          <v-icon left>mdi-briefcase-account</v-icon>
          Prospectos
          <v-chip x-small class="ml-2 white--text" color="green darken-2">2</v-chip>
        </v-tab>
        <v-tab>
          <v-icon left>mdi-file-document-edit</v-icon>
          Registros
          <v-chip x-small class="ml-2 white--text" color="green darken-2">3</v-chip>
        </v-tab>
        <!-- <v-tab>
          <v-icon left>mdi-file-document-edit</v-icon>
          Inscritos
          <v-chip x-small class="ml-2 white--text" color="green darken-2">4</v-chip>
        </v-tab> -->
        <!-- <v-tab>
          <v-icon left>mdi-file-document-edit</v-icon>
          Mis Inscripciones
          <v-chip x-small class="ml-2 white--text" color="green darken-2">4</v-chip>
        </v-tab> -->
      </v-tabs>

      <!-- <v-divider></v-divider> -->

      <v-card-text class="pa-0">
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <indexContactos ref="refindexContactos" />
          </v-tab-item>

          <v-tab-item>
            <!-- <indexProspectos ref="refindexProspectos" /> -->
            <MisInscripciones ref="refMisInscripciones1" :idfiltro="1" />
          </v-tab-item>
          <v-tab-item>
            <MisInscripciones ref="refMisInscripciones2" :idfiltro="2" />
          </v-tab-item>
          <!-- <v-tab-item>
            <MisInscripciones2 ref="refMisInscripciones2" :idfiltro="3" />
          </v-tab-item> -->
          <!-- <index_preregistros ref="refindex_preregistros" /> -->
          <!-- <v-tab-item>
            <index_preinscritos ref="refindex_preinscritos" />
          </v-tab-item> -->
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  import indexContactos from './index-contactos.vue';
  // import indexProspectos from './index-prospectos.vue';
  // import index_preregistros from './index_preregistros.vue';
  // import index_preinscritos from './index_preinscritos.vue';
  import MisInscripciones from '@/views/MisInscripciones.vue'
  // import MisInscripciones2 from '@/views/MisInscripciones.vue'
  export default {
    components: {
      indexContactos,
      // indexProspectos,
      // index_preinscritos,
      // index_preregistros,
      MisInscripciones,
      // MisInscripciones2,
    },
    data() {
      return {
        tab: 0,
      };
    },
    watch:{
      tab(t){
        window.sessionStorage.setItem('embudo-tab', t);
        if(this.$refs.refindexContactos && t == 0) this.$refs.refindexContactos.listar()
        else if(this.$refs.refMisInscripciones1 && t == 1) this.$refs.refMisInscripciones1.getFechasDefault(1)
        else if(this.$refs.refMisInscripciones2 && t == 2) this.$refs.refMisInscripciones2.getFechasDefault(2)
      }
    },
    mounted(){
      const xtab = window.sessionStorage.getItem('embudo-tab');
      if(xtab !== null){
        this.tab = parseInt(xtab, 10);
      }
    }
  };
</script>

<style scoped>
.prospectos-wrap {
  padding: 0px 16px 0px 16px;
}
.prospectos-card {
  border-radius: 16px;
  overflow: hidden;
}
.prospectos-hero {
  min-height: 88px;
  /* background: linear-gradient(120deg, #ff6a00 0%, #ff3d00 45%, #ffb300 100%); */
  background: linear-gradient(120deg, #0e4e97 0%, #176dc4 52%, #338fdb 100%);
}
.prospectos-tabs {
  background: #f5fbff;
}
</style>
